

import air from 'assets/png/nonfood-store/air_non_food.png';
import airActive from 'assets/png/nonfood-store/air_non_food_on.png';
import desk from 'assets/png/nonfood-store/desk_non_food.png';
import deskActive from 'assets/png/nonfood-store/desk_non_food_on.png';
import door from 'assets/png/nonfood-store/door_non_food.png';
import doorActive from 'assets/png/nonfood-store/door_non_food_on.png';
import heating from 'assets/png/nonfood-store/heating_non_food.png';
import heatingActive from 'assets/png/nonfood-store/heating_non_food_on.png';
import lights from 'assets/png/nonfood-store/lights_non_food.png';
import lightsActive from 'assets/png/nonfood-store/lights_non_food_on.png';
import spots from 'assets/png/nonfood-store/spots_non_food.png';
import spotsActive from 'assets/png/nonfood-store/spots_non_food_on.png';
import window from 'assets/png/nonfood-store/window_non_food.png';
import windowActive from 'assets/png/nonfood-store/window_non_food_on.png';

import boots from 'assets/png/nonfood-store/boots_non_food.png';
import manikinWindow from 'assets/png/nonfood-store/manikin_window_non_food.png';
import plant from 'assets/png/nonfood-store/plant_non_food.png';
import wardrobe from 'assets/png/nonfood-store/wardrobe_non_food.png';

import background from 'assets/png/nonfood-store/Non_Food_BG.png';

export default {
  exitLabel: 'Laden verlassen',
  background: {
    src: background,
  },
  items: {
    air: {
      baseSrc: air,
      activeSrc: airActive,
      height: 4.6,
      top: 11.8,
      left: 36.9,
      level: 0,
      infopanel: {
        content: {
          title: 'Raumluft',
          description: 'Als Einzelhändler wissen Sie genau, wie wichtig eine optimale Temperierung und Luftqualität in Verkaufsräumen ist. Zum Beispiel im Winter, wenn Kunden ihre Jacken und Mäntel beim Einkaufen anlassen, das Personal im Geschäft jedoch eine angenehme Arbeitsumgebung braucht. Die richtige Einstellung der Raumluft ist kein Kinderspiel und erfordert technisches Know-how. Wir helfen Ihnen weiter und erklären, worauf es ankommt.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/raumluft?pk_campaign=virtuelle-marktstrasse&pk_source=petramoden&pk_content=raumluft',
          },
        },
        overlay: {
          x: 'right',
          y: 'bottom',
        },
        button: {
          top: 65,
          left: 87,
        },
      },
    },
    desk: {
      baseSrc: desk,
      activeSrc: deskActive,
      height: 15,
      top: 36.6,
      left: 46.3,
      level: 0,
      infopanel: {
        content: {
          title: 'Förderprogramme',
          description: 'Sie wollen Energie sparen, wissen aber einfach nicht, wie Sie das finanzieren können? Gute Nachrichten: Der Bund und auch einige Bundesländer unterstützen den Einzelhandel finanziell bei der Umsetzung von Klimaschutzmaßnahmen! Welche Förderung für Sie am besten geeignet ist und wie Sie ganz einfach einen Förderantrag stellen, erklären wir Ihnen Schritt für Schritt',
          link: {
            title: 'Jetzt fördern lassen!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/werkzeuge/foerderprogramme?pk_campaign=virtuelle-marktstrasse&pk_source=petramoden&pk_content=foerderprogramme&term= ',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 33.5,
          left: -5.2,
        },
      },
    },
    door: {
      baseSrc: door,
      activeSrc: doorActive,
      height: 19.6,
      top: 29,
      left: 39.4,
      level: 0,
      infopanel: {
        content: {
          title: 'Energiemanagement',
          description: 'Obwohl sich Investitionen in Energieeffizienz oft innerhalb kurzer Zeit amortisieren, zögern viele Einzelhändler bei der Umsetzung. Kommt Ihnen das bekannt vor? Dabei ist der Anfang leicht gemacht: Mit einem systematischen Energiemanagement beginnen Sie Verbräuche und Kosten zu analysieren und mit geeigneten Maßnahmen nachhaltig zu senken. Los geht’s!',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/energiemanagement?pk_campaign=virtuelle-marktstrasse&pk_source=petramoden&pk_content=energiemanagement',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: -7,
          left: -14,
        },
      },
    },
    heating: {
      baseSrc: heating,
      activeSrc: heatingActive,
      height: 17.08,
      top: 56.9,
      left: 0.625,
      level: 0,
      infopanel: {
        content: {
          title: 'Heizen',
          description: 'Ist Ihre Heizanlage schon etwas älter? Moderne Heiztechnik und clevere Umrüstungen bieten viele Möglichkeiten, um Energiekosten zu sparen. Sie können dabei sogar auf umweltfreundliche Energieträger umsteigen und nebenbei das Klima schützen. Setzen Sie Ihre Heizanlange auf den Prüfstand – wir gehen die ersten Schritte mit Ihnen.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/heizen?pk_campaign=virtuelle-marktstrasse&pk_source=petramoden&pk_content=heizen',
          },
        },
        overlay: {
          x: 'right',
          y: 'top',
        },
        button: {
          top: -10,
          left: 90,
        },
      },
    },
    spots: {
      baseSrc: spots,
      activeSrc: spotsActive,
      height: 15.7,
      top: 7.6,
      left: 25.4,
      level: 0,
      infopanel: {
        content: {
          title: 'Lichtsteuerung',
          description: 'Möchten Sie wissen, wie Sie Ihr Licht so steuern können, dass Ihr Geschäft optimal und effizient beleuchtet ist? Wir helfen Ihnen dabei, Ihre Beleuchtung zu professionalisieren: Ob Zeitsteuerung, Präsenzerfassung oder Tageslichtregelung – mit einer zentralen Lichtsteuerung können Sie Ihre Stromkosten halbieren. ',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/lichtsteuerung?pk_campaign=virtuelle-marktstrasse&pk_source=petramoden&pk_content=lichtsteuerung',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 34,
          left: -6.5,
        },
      },
    },
    lights: {
      baseSrc: lights,
      activeSrc: lightsActive,
      height: 31.9,
      top: 3.1,
      left: 62.6,
      level: 0,
      infopanel: {
        content: {
          title: ' LED-Leuchtmittel',
          description: 'Die Umstellung von konventionellen Leuchtmitteln auf LED-Lampen ist schon jetzt eine der beliebtesten Energieeffizienzmaßnahmen im Einzelhandel. Je nach bisher eingesetzter Technik können Sie damit Ihre Stromkosten halbieren. Mit den neuen Lampen lassen sich Waren außerdem viel eindrucksvoller präsentieren.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/austausch_beleuchtung?pk_campaign=virtuelle-marktstrasse&pk_source=petramoden&pk_content=austausch_beleuchtung',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: -2,
          left: -4,
        },
      },
    },
    window: {
      baseSrc: window,
      activeSrc: windowActive,
      height: 54.2,
      top: 15.8,
      left: 88,
      level: 0,
      infopanel: {
        content: {
          title: 'Dämmen',
          description: 'Gerade über große Fensterflächen geht viel wertvolle Wärme verloren. Ohne eine effektive Dämmung Ihres Gebäudes wird es langfristig nicht möglich sein, Energie und Heizkosten zu sparen. Hier erfahren Sie, wie Sie in Aktion treten können.',
          link: {
            title: 'Jetzt handeln!',
            url: 'https://www.hde-klimaschutzoffensive.de/de/daemmen_gebaeudehuelle?pk_campaign=virtuelle-marktstrasse&pk_source=petramoden&pk_content=daemmen_gebaeudehuelle',
          },
        },
        overlay: {
          x: 'left',
          y: 'bottom',
        },
        button: {
          top: 5,
          left: -7,
        },
      },
    },
    boots: {
      baseSrc: boots,
      height: 20.7,
      top: 56.9,
      left: 43.2,
      level: 1,
      ignoreEvents: true,
    },
    manikinWindow: {
      baseSrc: manikinWindow,
      height: 38.1,
      top: 33,
      left: 84.3,
      level: 1,
      ignoreEvents: true,
    },
    plant: {
      baseSrc: plant,
      height: 8.6,
      top: 33,
      left: 54.5,
      level: 1,
      ignoreEvents: true,
    },
    wardrobe: {
      baseSrc: wardrobe,
      height: 40.4,
      top: 50.3,
      left: 14.9,
      level: 1,
      ignoreEvents: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/ClothingStoreConfig.js